export default {
  updated: 'Updated',
  updateError: 'Error! Update unsuccessful',
  stored: 'Stored',
  storeError: 'Error! Store unsuccessful',
  suspended: 'Suspended',
  suspendError: 'Error! Suspend unsuccessful',
  restored: 'Restored',
  restoreError: 'Error! Restore unsuccessful',
  deleted: 'Deleted',
  deleteError: 'Error! Delete unsuccessful',
  added: 'Added',
  addError: 'Error! Add unsuccessful',
  removed: 'Removed',
  removeError: 'Error! Remove unsuccessful',
  confirm: 'Are you sure?',
}
